var map = {
	"./cart.json": 84538,
	"./check.json": 49723,
	"./checkList.json": 38389,
	"./clock.json": 91101,
	"./exclamation.json": 92133,
	"./loader.json": 9256,
	"./menu.json": 19380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79595;